import styled from '@emotion/styled'

export const PatternDiv = styled.div`
  background: url(/images/patterns/blue-pattern.png), linear-gradient(224.8deg, #397DCF 36.75%, #5FA9E9 98.03%);
  h1, h2, h3, h4, h5, h6, p {
    color: white;
  }
`
